import {  Typography, Grid, Chip  } from "@mui/material";
import { useState, useEffect } from 'react';
import Popper from '@mui/material/Popper';
import { ClickAwayListener } from '@mui/material';
import InnoTooltip from "../InnoTooltip";

const arrowStyle = {
  position: 'absolute',
  width: 0,
  height: 0,
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderBottom: '10px solid #fff', // Change the color as needed
  right: '0', // Align to the right,
  boxShadow: "0px 3px 6px #23247B45",
}
const tooltipStyle = {
    "& .MuiTooltip-tooltip": {
      width: "124px",
      fontSize: "14px",
      fontWeight: 700,
      fontFamily: "Lato",
      margin: "10px",
      backgroundColor: "#C30930",
    },
    "& .MuiTooltip-arrow": {
      color: "#C30930",
    },
};
export default function MenuDropdown({
  id, //required: id of the element you want to click to trigger popover event (anchored element)
  // handleClick, //required: function to call when you click element,
  anchorEl, // required: anchored element
  setAnchorEl, //required
  arrow, //optional: boolean
  setArrow, //optional: to close arrow
  optionList, //optional: to display in dropdown
  styledProps, //optional: for add styling
  pillForm, //optional: to change list from text to pills
  }) {

    const [arrowRef, setArrowRef] = useState(null);

    useEffect(()=> {
      function clickAway(event) {
        if (anchorEl && !anchorEl.contains(event.target)) {
          handleClose();
          if (setArrow) setArrow(false);
          if (arrowRef) setArrowRef(null)
        }
      }

      document.addEventListener("mousedown", clickAway)
      return () => document.removeEventListener("mousedown", clickAway)
      }, [anchorEl])

    const preventClose = (event) => {
      event.stopPropagation();
    }

    const handleClose = () => {
      setAnchorEl(null);
    };



    const open = Boolean(anchorEl);
    
    return (
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        placement={"bottom-end"}
        modifiers={
          !arrow
            ? null
            : [
                {
                  name: "arrow",
                  enabled: arrow,
                  options: {
                    element: arrowRef,
                  },
                },
              ]
        }
        sx={{
          position: "relative",
          zIndex: 500,
        }}>
        <ClickAwayListener onClickAway={handleClose}>
          <>
            {arrow ? (
              <div
                className="arrow1"
                style={{
                  ...arrowStyle,
                }}
                ref={setArrowRef}></div>
            ) : null}
            <Grid
              onClick={preventClose}
              onMouseDown={preventClose}
              container
              flexDirection="column"
              alignItems="center"
              justifyContent="flex-start"
              className="menu-dropdown-background"
              sx={{
                // the product spec is very small, so i made it bigger
                maxWidth: "120px",
                background: "white",
                borderRadius: "3.8px",
                boxShadow: "0px 3px 6px #23247B45",
                opacity: 1,
                position: "relative",
                top: arrow ? "10px" : 0,
                left: arrow ? "10px" : 0,
                ...(styledProps ? styledProps : {}),
              }}>
              {optionList &&
                optionList.map((item) => (
                    <Grid
                      key={item.name}
                      item
                      onClick={item?.disabled ? undefined : (e) => item.handleFunc(e)}
                      sx={{
                      maxHeight: "38px",
                      width: "100%",
                      margin: "5px 0px 5px 0px",
                      paddingLeft: "8px",
                      wordWrap: "break-word",
                      whiteSpace: "pre-wrap",
                      cursor: item?.disabled ? "default" : "pointer",
                      "&:hover": {
                        backgroundColor: item?.disabled ? null : "#EAF9FF",
                      },
                      ...(item.styledProps ? item.styledProps : {}),
                    }}>
                      {/* added a pillForm check to utilize the component without having to remake */}
                    {pillForm ? 
                    <Chip
                        sx={{
                          ...styledProps, border: `1.5px, solid, ${item.styledProps.color}`, height: item.styledProps.height, "&:hover": {
                            backgroundColor: "#EBF8FF",
                          }, }}
                      label={
                        <Grid
                          sx={
                            item.styledProps
                          } >
                          <Typography
                            sx={{
                              textAlign: "center",
                              fontFamily: `Lato`,
                              fontWeight: "700",
                              letterSpacing: "0px",
                              fontSize: "10px",
                              color: item.styledProps.color,
                              opacity: "1",
                            }}>
                            {item.name}
                          </Typography>
                          </Grid >
                      }/> : 
                  <InnoTooltip key={item.name} title={item?.disabled ? item?.disableText : ""} placement="left" sxStyle={tooltipStyle}>
                    <Typography
                      sx={{
                        fontFamily: "Lato",
                        fontWeight: "bold",
                        fontSize: "14px",
                        lineHeight: "18px",
                        letterSpacing: "0px",
                        color: item?.disabled ? "var(--Neutrals-500, #E2E6E9)" : "black",
                        opacity: 1,
                        ...(item.styledProps ? item.styledProps : {}),
                      }}>
                      {item.name?.length > 22
                        ? item.name.slice(0, 21) + "..."
                        : item.name}
                    </Typography>
                    </InnoTooltip>}
                  </Grid>
                ))}
            </Grid>
          </>
        </ClickAwayListener>
      </Popper>
    );
}